import React from 'react';
import I18nProvider from '@exc-ui/exc-sdk/dist/production/localization/i18n';
import ExpLogin from './ExpLogin';
import * as localizationStrings from './__localization__/ExpLogin';

function ExpLoginWrapper({ ...props }) {
  const localeData = {};
  const test = 'hello';
   Object.keys(localizationStrings).map(local => {
     const localeKey = local.replace(/_/g, '-');

     localeData[localeKey] = localizationStrings[local];
  });
  return (
    <I18nProvider autoLocale={true} localeData={localeData}>
      {<ExpLogin/>}
    </I18nProvider>
  );
}

ExpLoginWrapper.displayName = 'ExpLoginWrapper';

export default ExpLoginWrapper;



// WEBPACK FOOTER //
// ./src/components/ExpLogin/ExpLoginWrapper.js